/**
 * AshePainter — Single Responsibility: dibujar el modelo 2D de Ashe.
 * Contrato: paint(ctx, pos, radius, entity) → void
 */
export const AshePainter = {
  paint(ctx, pos, radius, _entity) {
    // Frost Archer Cloak
    ctx.beginPath();
    ctx.arc(-radius * 0.5, 0, radius * 0.9, 0, Math.PI * 2);
    ctx.fillStyle = '#1e3a8a';
    ctx.fill();

    // Frost Bow
    ctx.beginPath();
    ctx.arc(radius * 0.6, 0, radius * 0.8, -Math.PI * 0.4, Math.PI * 0.4);
    ctx.strokeStyle = '#00f0ff';
    ctx.lineWidth = 3.5;
    ctx.stroke();
  }
};
